(() => {
  // Live listings keep the existing native photo-choice navigation.
  if (!location.hostname.endsWith('.shopifypreview.com')) return;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('custom-photo-colors-v1 a.custom-photo-colors-v1__choice');
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const widget = link.closest('custom-photo-colors-v1');
    let data;
    try { data = JSON.parse(widget.querySelector('[data-photo-color-data]').textContent); } catch { return; }
    const choice = data.choices?.find((item) => new URL(item.url, location.origin).pathname === new URL(link.href).pathname);
    if (!choice?.previewUrl || !choice.sizeVariants) return;
    const picker = widget.closest('product-info')?.querySelector('variant-selects');
    const sizeField = [...picker?.querySelectorAll('fieldset') || []].find((field) => field.querySelector('input[data-option-name="Size"]') || [...field.querySelectorAll('input')].some((input) => /^Size(?:-|$)/i.test(input.name.trim())));
    const size = sizeField?.querySelector('input:checked')?.value || data.selectedOptions?.[data.optionNames?.indexOf('Size')];
    const destination = new URL(choice.previewUrl);
    if (choice.sizeVariants[size]) destination.searchParams.set('variant', choice.sizeVariants[size]);
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(destination.href);
  }, true);
})();
